import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import "../../assets/scss/pages/_assign-work.scss";
import MultipleDownloadfile from "../common/multiple-downloadfile";
import { getServiceFee } from "../utils/check-value";
import { setStringFileNameToArray, TransformColumnToArray } from "../utils/format-value";
import ConfigData from "../../config.json";
import axios from "axios";
import Swal from "sweetalert2";
import DownloadPDF from "../common/pdf-download";
import { IconLoading } from "../common/popup-alert";

const AssignDetailLdr = ({ requestDetail, requestTemplateDetail }) => {
  const accessToken = localStorage.getItem("tkd");
  const [requestType, setRequestType] = useState([]);
  const [forUseDoc, setForUseDoc] = useState([]);
  const [memoDoc, setMemoDoc] = useState([]);
  const [allReqDoc, setAllReqDoc] = useState([]);
  const modelFormDocCert = { doc_cert_bu: '', name_doc_cert_bu: '', doc_cert_bu_other: '', doc_cert_bu_expire: '', doc_cert_amount: ''};
  const modelFormDocPassport = { doc_passport_name: '', doc_passport_amount: '' };
  const modelFormDocIdCard = { doc_idcard_name: '', doc_idcard_amount: '' };
  const modelFormDocIdCardHouse = { doc_idcard_house_name: '', doc_idcard_house_amount: '' };
  const modelFormDocShareholders = { doc_shareholders_bu: '', name_doc_shareholders_bu: '', doc_shareholders_bu_other: '', doc_shareholders_expire: '', doc_shareholders_amount: ''};
  const modelFormDocTaxBranch = { doc_tax_branch_name: '', doc_tax_branch_amount: '' };
  const modelFormDocOther = { doc_other_name: '', doc_other_expire: '', doc_other_amount: '', doc_other_reason: '' };
  const [userDetail, setUserDetail] = useState({
    "id": 0,
    "id_business_unit": 0,
    "id_user_group": 0,
    "email": "",
    "name": "",
    "surname": "",
    "business_unit": "",
    "department": "",
    "user_group": "",
    "status": ""
  });
  const [userCoordinate, setUserCoordinate] = useState({
    "id": 0,
    "id_business_unit": 0,
    "id_user_group": 0,
    "email": "",
    "name": "",
    "surname": "",
    "business_unit": "",
    "department": "",
    "user_group": "",
    "status": ""
  });

  useEffect(() => {
    if(requestDetail.id > 0 && requestTemplateDetail.id > 0){
      showLoading(true);
      LoadRequestType(requestTemplateDetail.id_request_type);
      if(requestDetail.create_request_by !== "" && requestDetail.create_request_by !== null){
        LoadUserInfo(requestDetail.create_request_by, setUserDetail);
        LoadUserInfo(requestDetail.request_by, setUserCoordinate);
      }else{
        LoadUserInfo(requestDetail.request_by, setUserDetail);
      }
      
      let arrFormDocCert = TransformColumnToArray(requestTemplateDetail, modelFormDocCert, 5);
      arrFormDocCert = (arrFormDocCert === null) ? [] : arrFormDocCert.map(item => ({...item, source: 'doc_cert'}));
      let arrFormDocPassport = TransformColumnToArray(requestTemplateDetail, modelFormDocPassport, 5);
      arrFormDocPassport = (arrFormDocPassport === null) ? [] : arrFormDocPassport.map(item => ({...item, source: 'doc_passport'}));
      let arrFormDocIdCard = TransformColumnToArray(requestTemplateDetail, modelFormDocIdCard, 5);
      arrFormDocIdCard = (arrFormDocIdCard === null) ? [] : arrFormDocIdCard.map(item => ({...item, source: 'doc_idcard'}));
      let arrFormDocIdCardHouse = TransformColumnToArray(requestTemplateDetail, modelFormDocIdCardHouse, 5);
      arrFormDocIdCardHouse = (arrFormDocIdCardHouse === null) ? [] : arrFormDocIdCardHouse.map(item => ({...item, source: 'doc_idcard_house'}));
      let arrFormDocShareholders = TransformColumnToArray(requestTemplateDetail, modelFormDocShareholders, 5);
      arrFormDocShareholders = (arrFormDocShareholders === null) ? [] : arrFormDocShareholders.map(item => ({...item, source: 'doc_shareholders'}));
      let arrFormTaxHeadOffice = [];
      if(requestTemplateDetail.doc_tax_head_office_amount > 0){
        arrFormTaxHeadOffice.push({ doc_tax_branch_name: 'สำนักงานใหญ่', doc_tax_branch_amount: requestTemplateDetail.doc_tax_head_office_amount, is_branch: false, source: 'doc_tax_branch' })
      }
      let arrFormDocTaxBranch = TransformColumnToArray(requestTemplateDetail, modelFormDocTaxBranch, 5);
      arrFormDocTaxBranch = (arrFormDocTaxBranch === null) ? [] : arrFormDocTaxBranch.map(item => ({...item, is_branch: true, source: 'doc_tax_branch'}));
      let arrFormDocOther = TransformColumnToArray(requestTemplateDetail, modelFormDocOther, 10);
      arrFormDocOther = (arrFormDocOther === null) ? [] : arrFormDocOther.map(item => ({...item, source: 'doc_other'}));

      let arrAllDoc = [].concat(arrFormDocCert, arrFormDocPassport, arrFormDocIdCard, arrFormDocIdCardHouse, arrFormDocShareholders, arrFormTaxHeadOffice, arrFormDocTaxBranch, arrFormDocOther);
      setAllReqDoc(arrAllDoc);

      setForUseDoc(setStringFileNameToArray(requestTemplateDetail.for_use_doc));
      setMemoDoc(setStringFileNameToArray(requestDetail.memo_doc));
      showLoading(false);
    }
  }, [requestDetail, requestTemplateDetail]);

  const showLoading = (isShow) => {
    if (isShow) {
      Swal.fire({
        iconHtml: IconLoading,
        title: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  };

  const RenderFormDocCert = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  สำเนาหนังสือรับรองของ บริษัท {data.name_doc_cert_bu || "-"}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_cert_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                อายุของหนังสือรับรอง
              </Label>
              <Label className="content-val mb-0">
                {data.doc_cert_bu_expire || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocPassport = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  สำเนาหนังสือเดินทาง ชื่อ {data.doc_passport_name || "-"}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_passport_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocIdCard = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  สำเนาบัตรประชาชน ชื่อ {data.doc_idcard_name || "-"}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_idcard_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocIdCardHouse = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                  <Label className="content-name mb-0">
                      {index + 1}. เอกสารที่ขอ
                  </Label>
                  <Label className="content-val mb-0">
                    สำเนาบัตรประชาชนและทะเบียนบ้าน ชื่อ {data.doc_idcard_house_name || "-"}
                  </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
                <Label className="content-name mb-0">
                  จำนวน (Copies)
                </Label>
                <Label className="content-val mb-0">
                  {data.doc_idcard_house_amount || "-"}
                </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocShareholders = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  สำเนาบัญชีรายชื่อผู้ถือหุ้น บริษัท {data.name_doc_shareholders_bu || "-"}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_shareholders_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                อายุของหนังสือรับรอง
              </Label>
              <Label className="content-val mb-0">
                {data.doc_shareholders_expire || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocTax = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  ใบทะเบียนภาษีมูลค่าเพิ่ม {((data.is_branch === true) ? "สาขา " : "") + (data.doc_tax_branch_name || "-")}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_tax_branch_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const RenderFormDocOther = (data, index) => {
    return (
      <div className="mb-2">
        <Row>
          <Col md={8}>
              <div className="body-content-min">
                <Label className="content-name mb-0">
                    {index + 1}. เอกสารที่ขอ
                </Label>
                <Label className="content-val mb-0">
                  อื่นๆ : {data.doc_other_name || "-"}
                </Label>
              </div>
          </Col>
          <Col md={4}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                จำนวน (Copies)
              </Label>
              <Label className="content-val mb-0">
                {data.doc_other_amount || "-"}
              </Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                อายุของหนังสือรับรอง
              </Label>
              <Label className="content-val mb-0">
                {data.doc_other_expire || "-"}
              </Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="body-content-min">
              <Label className="content-name mb-0">
                เหตุผลที่ต้องใช้
              </Label>
              <Label className="content-val mb-0">
                {data.doc_other_reason || "-"}
              </Label>
            </div>
          </Col>
        </Row>
      </div>
    );
  };
  
  //#region Call APIs
  const LoadRequestType = (requestTypeId) => {
    if (typeof requestTypeId === "undefined" || requestTypeId === null) {
      return;
    }
    let url = ConfigData.API_URL + "request-type/" + requestTypeId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setRequestType(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserInfo = (email, setValue) => {
    let url = ConfigData.API_URL + "user/search?email=" + email;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setValue(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //#endregion Call APIs

  return (
    <React.Fragment>
      <Row>
        <Col xl={12} className="mx-auto">
          <DownloadPDF fileName={`form-ldr-${requestDetail.request_no}.pdf`} type={"formLabel"} >
            <div className="page-content-assign">
              <Row id="section-page-1-1">
                <Col md={12}>
                  <Row>
                    <Col md={10}>
                      <div className="header-content">
                        ข้อมูลของผู้ทำคำขอ (User Information)
                      </div>
                    </Col>
                    <Col md={2}>
                      <div id="section-page-hide-input" className="header-form">
                        <span>
                          <Label htmlFor="export-pdf" className="form-export-file-label">
                            <i className="mdi mdi-upload i-upload"></i>
                            Export
                          </Label>
                        </span>
                      </div>
                    </Col>
                  </Row>
                  
                  <div className="dashed-line"></div>
                  <Row>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          คำขอเลขที่ (Request No.)
                        </Label>
                        <Label className="content-val">
                          {requestDetail.request_no || "-"}
                        </Label>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          วันที่สร้างคำขอ (Date of Request)
                        </Label>
                        <Label className="content-val">
                          {requestDetail.request_date || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          ผู้ทำคำขอ (User’s Request)
                        </Label>
                        <Label className="content-val">
                          {userDetail.name + " " + userDetail.surname || "-"}
                        </Label>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          อีเมลผู้ทำคำขอ (User’s email)
                        </Label>
                        <Label className="content-val">
                          {userDetail.email || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          บริษัทที่สังกัด (User's BU)
                        </Label>
                        <Label className="content-val">
                          {userDetail.business_unit || "-"}
                        </Label>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="body-content">
                        <Label className="content-name">
                          แผนกที่สังกัด (User's Department)
                        </Label>
                        <Label className="content-val">
                          {userDetail.department || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {(requestDetail.create_request_by !== "" && requestDetail.create_request_by !== null) ? (
                <Row id="section-page-1-2">
                    <Col md={12}>
                        <div className="header-content">
                            ข้อมูลของผู้ประสานงานกลาง (User Coordinator Information)
                        </div>
                        <div className="dashed-line"></div>
                        <Row>
                            <Col md={6}>
                                <div className="body-content">
                                    <Label className="content-name">
                                        ผู้ประสานงานกลาง (Name of User Coordinator)
                                    </Label>
                                    <Label className="content-val">
                                        {userCoordinate.name + " " + userCoordinate.surname || "-"}
                                    </Label>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="body-content">
                                    <Label className="content-name">
                                        อีเมลผู้ประสานงาน (Coordinator’s Email)
                                    </Label>
                                    <Label className="content-val">
                                        {userCoordinate.email || "-"}
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="body-content">
                                    <Label className="content-name">
                                        บริษัทที่สังกัด (User's BU)
                                    </Label>
                                    <Label className="content-val">
                                        {userCoordinate.business_unit || "-"}
                                    </Label>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="body-content">
                                    <Label className="content-name">
                                        แผนกที่สังกัด (User's Department)
                                    </Label>
                                    <Label className="content-val">
                                        {userCoordinate.department || "-"}
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
              ) : null}
              <Row id="section-page-1-3">
                <Col md={12}>
                  <div className="header-content">
                    ข้อมูลทั่วไป (Request General Information)
                  </div>
                  <div className="dashed-line"></div>
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">ประเภทคำขอ (Type of Request)</Label>
                        <Label className="content-val">
                          {requestType.name_en || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">
                          งานของบริษัท (Company’s Work)
                        </Label>
                        <Label className="content-val">
                            {requestTemplateDetail.name_businessunit || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row id="section-page-1-4">
                <Col md={12}>
                  <div className="header-content">
                    วัตถุประสงค์ที่ต้องการเอกสารไปใช้ (Purpose)
                  </div>
                  <div className="dashed-line"></div>                  
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">
                          เหตุผลในการใช้เอกสาร (Purpose)
                        </Label>
                        <Label className="content-val">
                          {requestTemplateDetail.for_use || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="body-content mb-0">
                        <Label className="content-name">
                          เอกสารแนบ (Attachment)
                        </Label>
                        {forUseDoc.length > 0 ? (
                          <MultipleDownloadfile
                            folder={requestDetail.request_no}
                            dataFile={forUseDoc}
                          />
                        ) : (
                          <div>-</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row id="section-page-2-1">
                <Col md={12}>
                  <div className="header-content">เอกสารที่ต้องการขอ (Required Document)</div>
                  <div className="dashed-line"></div>
                </Col>
              </Row>
              {allReqDoc.map((item, index) => {
                return (
                  <Row id={"section-page-2-" + (index + 2)} key={"reqDoc" + index}>
                    <Col md={12}>
                      {(item.source === "doc_cert") ? RenderFormDocCert(item, index) : null}
                      {(item.source === "doc_passport") ? RenderFormDocPassport(item, index) : null}
                      {(item.source === "doc_idcard") ? RenderFormDocIdCard(item, index) : null}
                      {(item.source === "doc_idcard_house") ? RenderFormDocIdCardHouse(item, index) : null}
                      {(item.source === "doc_shareholders") ? RenderFormDocShareholders(item, index) : null}
                      {(item.source === "doc_tax_branch") ? RenderFormDocTax(item, index) : null}
                      {(item.source === "doc_other") ? RenderFormDocOther(item, index) : null}
                    </Col>
                  </Row>
                );
              })}
              {(requestTemplateDetail.reason_more_one_copy !== "" && requestTemplateDetail.reason_more_one_copy !== null) ? (
                <Row id="section-page-3-1">
                  <Col md={12}>
                    <div className="header-content">
                      มีการขอเอกสารมากกว่า 1 ชุด
                    </div>
                    <div className="dashed-line"></div>
                    <Row>
                      <Col md={12}>
                        <div className="body-content">
                          <Label className="content-name">
                            เหตุผลที่ขอเอกสารมากกว่า 1 ชุด<br />
                            The reason for requesting more than 1 copy of the document.
                          </Label>
                          <Label className="content-val">
                            {requestTemplateDetail.reason_more_one_copy || "-"}
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : null}
              <Row id="section-page-4-1">
                <Col md={12}>
                  <div className="header-content">
                    การรับรองสำเนาถูกต้อง (Certified True Copy)
                  </div>
                  <div className="dashed-line"></div>
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">
                          ต้องการรับรองสำเนาถูกต้องหรือไม่ (Certified True Copy)
                        </Label>
                        <Label className="content-val">
                          {(requestTemplateDetail.certified_true_copy === "1") ? "รับรองสำเนาถูกต้อง (Certified true copy)" : "ไม่รับรองสำเนาถูกต้อง (Not certified as a true copy)"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  {(requestTemplateDetail.certified_true_copy === "1") ? (
                    <Row>
                      <Col md={12}>
                        <div className="body-content mb-2">
                          <Label className="content-name">                          
                            แนบ Memo สำหรับการเสนอลงนาม (Attach Memo For Signing Procedure)
                          </Label>
                          {memoDoc.length > 0 ? (
                            <MultipleDownloadfile
                              folder={requestDetail.request_no}
                              dataFile={memoDoc}
                            />
                          ) : (
                            <div>-</div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                  <Row>
                    <Col md={12}>
                      <div className="body-content">
                        <Label className="content-name">
                          ผู้อนุมัติแบบคำขอ (User Approver)
                        </Label>
                        <Label className="content-val">
                          {requestDetail.approve_request_by || "-"}
                        </Label>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </DownloadPDF>
          
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AssignDetailLdr;
